// --------------------------------------------------------------
// Created On: 2024-04-02
// Author: Hannah Vaughan
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./PumpLink.module.scss";

// Component containing a square button with a customizable icon, description, and URL.
export default function PumpLink(props: Props): Component {
  return (
    <a href={props.url} target="_blank" rel="noreferrer">
      <div className="col-12" data-test="pump-link">
        <button
          type="button"
          className={`${styles.pumpLink} btn my-2 py-1 w-100 btn-primary`}
          data-test="pump-link-button"
        >
          <i className={`${props.iconClass} ${props.marginClass}`} data-test="pump-link-icon" aria-hidden="true"></i>
          <br />
          <p className={`${styles.pumpLinkText}`} data-test="pump-link-description">
            {props.description}
          </p>
        </button>
      </div>
    </a>
  );
}

interface Props {
  iconClass: string;
  marginClass: string;
  description: string;
  url: string;
}
